import qs from 'qs';
import client from './client';

const url = '/api/v1/sys/docu-rule';

// 문서번호 규칙 목록 + 현재 접두사
export const getDocuRules = () => client.get(`${url}/list`);

// 저장하지 않고 모양만 확인
export const previewDocuRule = (pattern, docuTyp) =>
  client.get(`${url}/preview?${qs.stringify({ pattern, docuTyp })}`);

export const saveDocuRule = (docuTyp, body) => client.put(`${url}/${docuTyp}`, body);
